import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, compose, map, flatten, filter } from 'ramda';

import Card from '../../../../components/Card';
import Resource from '../../../../components/Resource';
import { isNilOrEmpty } from '../../../../util/redux';

const propTypes = {
  resources: PropTypes.array,
  registrations: PropTypes.array,
};

const CertificationResources = ({ resources, registrations }) => {
  const courseMaterials = compose(
    filter((material) => !isNilOrEmpty(material)),
    flatten(),
    map((registration) => registration.courseMaterials),
  )(registrations);
  if (isEmpty(resources) && isEmpty(courseMaterials)) return <noscript />;

  return (
    <Card training className="mb-4">
      <Card.Header registration>
        Certification Resources
        {!isEmpty(courseMaterials) && (
          <div className="subheader">
            <span className="font-weight-bold">Purchased Course Materials: </span>
            {courseMaterials.map((material) => material.name).join(', ')}
          </div>
        )}
      </Card.Header>
      <Card.Body className="d-flex flex-wrap">
        {resources.map((resource) => (
          <Resource key={resource.id} resource={resource} />
        ))}
      </Card.Body>
    </Card>
  );
};

CertificationResources.propTypes = propTypes;

export default CertificationResources;
